/** @format */
import { MarketCode } from '@mpb-com/feather/enums';
import { TFunction } from 'next-i18next';

export const getMarketOptionMessage = (
    marketCode: MarketCode,
    language: string,
    t: TFunction
) => {
    switch (marketCode) {
        case MarketCode.DE_DE:
            return t('MPB in Germany', { lng: language, ns: 'global' });
        case MarketCode.FR_FR:
            return t('MPB in France', { lng: language, ns: 'global' });
        case MarketCode.EN_US:
            return t('MPB in the US (and rest of the world)', {
                lng: language,
                ns: 'global',
            });
        case MarketCode.EN_EU:
            return t('MPB in the EU', { lng: language, ns: 'global' });
        case MarketCode.EN_UK:
            return t('MPB in the UK', { lng: language, ns: 'global' });
        case MarketCode.NL_NL:
            return t('MPB in the Netherlands', { lng: language, ns: 'global' });
        case MarketCode.NL_BE:
            return t('MPB in Belgium (Dutch)', { lng: language, ns: 'global' });
        case MarketCode.FR_BE:
            return t('MPB in Belgium (French)', {
                lng: language,
                ns: 'global',
            });
        case MarketCode.EN_IE:
            return t('MPB in Ireland', { lng: language, ns: 'global' });
        case MarketCode.DE_AT:
            return t('MPB in Austria', { lng: language, ns: 'global' });
        case MarketCode.IT_IT:
            return t('MPB in Italy', { lng: language, ns: 'global' });
        case MarketCode.PT_PT:
            return t('MPB in Portugal', { lng: language, ns: 'global' });
        case MarketCode.ES_ES:
            return t('MPB in Spain', { lng: language, ns: 'global' });
    }
};
